import type { MessageKey } from "../i18n/en.ts";

/**
 * The map editor at `/quest/:id/route` only edits a quest's route, so messages the
 * editor can show there speak of the route, never of Pieces.
 */
export const ROUTE_WINDOW_MESSAGES: Partial<Record<MessageKey, MessageKey>> = {
  "brand.tagline": "qroute.title",
  "keymap.savePiece": "qroute.keymapSave",
  "keymap.exitEdit": "qroute.keymapDone",
  "mode.exit": "qroute.done",
  "workPrompt.body": "qroute.workPrompt",
  "saved.new": "qroute.defaultName",
  "route.disconnected": "qroute.disconnected",
  "stats.disconnected": "qroute.statsDisconnected",
  "edit.selectSmallerParts": "qroute.selectSmallerParts",
  "toast.locked": "qroute.locked",
  "cache.cleared": "qroute.cacheCleared",
  "confirm.signIn": "qroute.signInSave",
};

export type RouteAccess = "ok" | "notOwner" | "published";

/** Same rules as the server: author on a draft, or an admin on a published quest. */
export function routeAccess(quest: { mine?: boolean; status: string; can_edit?: boolean }): RouteAccess {
  if (quest.can_edit) return "ok";
  if (!quest.mine) return "notOwner";
  if (quest.status !== "draft") return "published";
  return "ok";
}

export function questRouteAdminLive(quest: { can_edit?: boolean; status: string }): boolean {
  return quest.can_edit === true && quest.status !== "draft";
}

/** Server errors written for the Piece editor read as the generic fallback here. */
export function mentionsPiece(text: string): boolean {
  return /piece|피스|그림|조각/i.test(text);
}
